module.exports = __webpack_public_path__ + "static/img/voice1_left.b98c474e.png";